import angular from 'angular';
import constants from 'app/constants';
import {
  amSharedModelService,
  loaderService,
  ssDialogService,
  userService,
} from 'app/services';
import { alerts } from 'app/components/global';
import addAuditAgencyDialog from '../dialog.addAuditAgencyDialog';
import deleteAgencyConfirmDialog from '../dialog.deleteAgencyConfirmDialog';
import controller from './agency.controller';
import directive from './agency.directive';


export default angular.module('app.components.advisory.auditTrail.agency', [
  addAuditAgencyDialog,
  alerts,
  amSharedModelService,
  constants,
  deleteAgencyConfirmDialog,
  loaderService,
  ssDialogService,
  userService,
])
  .directive('amAgency', directive)
  .controller('AgencyController', controller)
  .name;

console.log('app.components.advisory.auditTrail.agency created');
